import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  organization: {
    id: 'studio.K56Dim',
    defaultMessage: 'Organization',
  },
  title: {
    id: 'studio.AsB1PR',
    defaultMessage: 'Organization {name}',
  },
  error: {
    id: 'studio.E/jnV9',
    defaultMessage: 'Something went wrong trying to fetch this organization.',
  },
  loading: {
    id: 'studio.MTVIlV',
    defaultMessage: 'Loading organization…',
  },
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
  settings: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  members: {
    id: 'studio.+a+2ug',
    defaultMessage: 'Members',
  },
  collections: {
    id: 'studio.iKi9+h',
    defaultMessage: 'App collections',
  },
  subscriptions: {
    id: 'studio.J+dIsA',
    defaultMessage: 'Subscriptions',
  },
  invoices: {
    id: 'studio.6dqYnF',
    defaultMessage: 'Invoices',
  },
});
